import { Controller } from '@hotwired/stimulus'

// Collapsible section headers for the legacy Tabler sidebar.
// Provider sections default to open; a header with
// data-menu-sections-default-collapsed="true" starts collapsed instead.
// Toggling is per-session only — no localStorage persistence.
//
// DOM expectations:
//   <ul data-controller="menu-sections">
//     <li class="sidebar-section-header" data-menu-sections-target="header"
//         data-action="click->menu-sections#toggle">…</li>
//     <li>…</li>   ← entry sibling, collapsed/expanded as a group
//     <li>…</li>
//     <li class="sidebar-section-header" data-menu-sections-target="header" …>…</li>
//     …
//   </ul>
//
// Coexistence with menu-search:
//   menu-search hides the whole [data-menu-search-target="menu"] block (the <ul>
//   itself) when searching, so section-collapse state is irrelevant while search
//   is active — the controllers never touch each other's targets.

export default class extends Controller {
  static targets = ['header']

  connect() {
    for (const header of this.headerTargets) {
      if (header.dataset.menuSectionsDefaultCollapsed === 'true') {
        this._collapse(header)
      } else {
        header.setAttribute('aria-expanded', 'true')
      }
    }
  }

  toggle(event) {
    const header = event.currentTarget
    const isOpen = header.getAttribute('aria-expanded') !== 'false'
    const nowOpen = !isOpen

    if (nowOpen) {
      header.setAttribute('aria-expanded', 'true')
      header.classList.remove('sidebar-section-collapsed')
      for (const li of this._entriesAfter(header)) {
        li.hidden = false
      }
    } else {
      this._collapse(header)
    }
  }

  _collapse(header) {
    header.setAttribute('aria-expanded', 'false')
    header.classList.add('sidebar-section-collapsed')
    for (const li of this._entriesAfter(header)) {
      li.hidden = true
    }
  }

  // Returns all sibling <li> elements that follow `header` until the next
  // .sidebar-section-header (or the end of the parent).
  _entriesAfter(header) {
    const entries = []
    let sibling = header.nextElementSibling
    while (sibling) {
      if (sibling.classList.contains('sidebar-section-header')) break
      entries.push(sibling)
      sibling = sibling.nextElementSibling
    }
    return entries
  }
}
